import { SVGProps, Ref, forwardRef } from 'react';

export const ChartLineOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.734 16c0-3.19.117-5.52.445-7.261.324-1.719.81-2.626 1.372-3.188.562-.561 1.47-1.048 3.188-1.372C10.48 3.85 12.81 3.733 16 3.733s5.52.118 7.262.446c1.718.324 2.625.81 3.187 1.372s1.049 1.47 1.372 3.188c.328 1.741.446 4.071.446 7.261s-.117 5.52-.446 7.261c-.323 1.719-.81 2.626-1.372 3.188-.562.561-1.47 1.048-3.187 1.372-1.742.328-4.072.446-7.262.446s-5.52-.118-7.261-.446c-1.718-.324-2.626-.81-3.188-1.372-.561-.562-1.048-1.47-1.372-3.188-.328-1.741-.446-4.071-.446-7.261m-2.4 0C1.334 3.167 3.167 1.333 16 1.333S30.667 3.167 30.667 16 28.833 30.667 16 30.667 1.334 28.833 1.334 16m16 5.03 8.363-8.363L24 10.97l-6.667 6.666-4.666-4.666-6.364 6.364L8 21.03l4.667-4.667z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChartLineOutlinedSize32Glyph.displayName = 'ChartLineOutlinedSize32Glyph';
